import { Tip } from '@model';
import { Action } from '@ngrx/store';

export enum TipActionTypes {
    TipSetAsRead = '[Tips] Set Tip as Read',
    TipSetAsReadSuccess = '[Tips] Set Tip as Read Success',
    TipSetAsReadFail = '[Tips] Set Tip as Read Fail',
    TipsLoad = '[Tips] Tips Load',
    TipsLoadSuccess = '[Tips] Tips Load Success',
    TipsLoadFail = '[Tips] Tips Load Fail',
    TipsOpen = '[Tips] Open Tip Window',
    TipsClose = '[Tips] Close Tip Window',
}

export class TipSetAsRead implements Action{
    readonly type = TipActionTypes.TipSetAsRead;
    constructor(public payload: Tip){}
}

export class TipSetAsReadSuccess implements Action{
    readonly type = TipActionTypes.TipSetAsReadSuccess;
    constructor(public payload: Tip){}
}

export class TipSetAsReadFail implements Action {
    readonly type = TipActionTypes.TipSetAsRead;
    constructor(public payload: any) {}
}

export class TipsLoad implements Action{
    readonly type = TipActionTypes.TipsLoad;
    constructor(){}
}

export class TipsLoadSuccess implements Action{
    readonly type = TipActionTypes.TipsLoadSuccess;
    constructor(public payload: Tip[]){}
}

export class TipsLoadFail implements Action{
    readonly type = TipActionTypes.TipsLoadFail;
    constructor(public payload: any){}
}

export class TipsOpen implements Action{
    readonly type = TipActionTypes.TipsOpen;
    constructor(){}
}

export class TipsClose implements Action{
    readonly type = TipActionTypes.TipsClose;
    constructor(){}
}

export type TipActions = 
    | TipSetAsRead 
    | TipSetAsReadSuccess
    | TipSetAsReadFail
    | TipsLoad
    | TipsLoadSuccess 
    | TipsLoadFail
    | TipsOpen
    | TipsClose;